import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { useMediaQuery, useTheme } from "@mui/material";
import { getStaticFileUrl } from "./utils/config";

const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#000000", // 어두운 배경색
  color: "#FFFFFF",
  padding: theme.spacing(3, 2),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start", // 텍스트 좌측 정렬
  textAlign: "left",
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(6, 8), // 화면 크기에 따라 패딩 조정
  },
}));

const FooterContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(2), // 로고와 텍스트 사이 간격
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column", // 모바일에서는 세로 정렬
    alignItems: "flex-start",
  },
}));

const FooterText = styled(Typography)(({ theme }) => ({
  color: "#A7A7A7",
  marginBottom: theme.spacing(1),
}));

function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [footerData, setFooterData] = useState({
    address: '서울특별시 영등포구 양평동3가 16, 612호',
    phone: '02-2088-7388',
    email: 'che37412@hanmail.net',
    companyName: '씨유미디어그룹',
  });

  useEffect(() => {
    // API에서 푸터 데이터 불러오기
    const loadFooterData = async () => {
      try {
        const { sidebarApi } = await import('./services/api');
        const data = await sidebarApi.get();
        if (data) {
          setFooterData(prev => ({
            ...prev,
            address: data.address || prev.address,
            phone: data.phone || prev.phone,
            email: data.email || prev.email,
            companyName: data.companyName || prev.companyName,
          }));
        }
      } catch (error) {
        console.error('푸터 데이터 로드 실패:', error);
      }
    };

    loadFooterData();
  }, []);

  return (
    <FooterContainer>
      {/* 로고 & 회사 정보 */}
      <FooterContent>
        {/* 로고 이미지 */}
        <Box
          component="img"
          src={getStaticFileUrl("/img/logo_white.png")} // 로고 이미지 경로
          alt="Company Logo"
          sx={{
            width: isMobile ? "3rem" : "5rem", // 반응형 크기 조정
            height: "auto",
          }}
        />

        {/* 텍스트 정보 */}
        <Box>
          <FooterText variant="body2">
            본사: {footerData.address} | TEL: {footerData.phone} |
            E-MAIL: {footerData.email}
          </FooterText>
          <FooterText variant="body2">
            COPYRIGHT &copy; {new Date().getFullYear()} {footerData.companyName.toUpperCase()} ALL RIGHTS
            RESERVE
          </FooterText>
        </Box>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer;
